/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Temperature Icon component.
 */
export const TemperatureIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='TemperatureIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M22.7028 9.42432H31.5433' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
        <path d='M22.7028 15.0073H27.123' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
        <path d='M22.7028 20.269H31.5433' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
        <path d='M17.0788 21.6036V9.13999C17.0788 8.3124 16.75 7.5187 16.1648 6.9335C15.5796 6.3483 14.786 6.01953 13.9584 6.01953C13.1329 6.02283 12.3424 6.353 11.7599 6.93784C11.1774 7.52269 10.8504 8.31455 10.8504 9.13999V23.7633C9.8636 24.4547 9.12531 25.4451 8.74455 26.5883C8.3638 27.7315 8.36073 28.9669 8.73587 30.1119C9.111 31.257 9.84446 32.251 10.8279 32.9473C11.8113 33.6436 12.9925 34.0052 14.1971 33.9787C15.4018 33.9522 16.5658 33.539 17.5177 32.8001C18.4695 32.0613 19.1586 31.036 19.483 29.8755C19.8074 28.7151 19.7501 27.4811 19.3194 26.3557C18.8887 25.2304 18.1076 24.2733 17.0913 23.6259L17.0788 21.6036Z'
          stroke={iconColor}
          strokeWidth='1.5'
          strokeMiterlimit='10'/>
        <circle cx='14.0711' cy='28.2196' r='2.06771' stroke={iconColor} strokeWidth='1.5'/>
        <path d='M13.9211 25.4014L13.9211 10.4683' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round'/>
      </svg>
    )} />
  );
};
